import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { SHOW_MODAL, MODAL_CONFIRM, MODAL_CANCEL, HIDE_MODAL } from "../action_types/modals";
function buildMiddleware() {
  var promise_list = {};
  var cleanup = function cleanup(modal_name) {
    promise_list[modal_name].accept = null;
    promise_list[modal_name].reject = null;
  };
  return function () {
    return function (next) {
      return function (action) {
        var nextAction = next(action);
        if (!action || !action.__modal) return nextAction;
        if (!action.modal_name) return nextAction;
        var modal_name = action.modal_name;
        if (!promise_list[modal_name]) promise_list[modal_name] = {
          promise: null,
          accept: null,
          reject: null,
          accept_value: null,
          reject_value: null
        };
        if (action.type === SHOW_MODAL) {
          if (promise_list[modal_name].promise) return promise_list[modal_name].promise;
          promise_list[modal_name].accept_value = null;
          promise_list[modal_name].reject_value = null;
          var returnValue = new Promise(function (accept, reject) {
            promise_list[modal_name].accept = function (value) {
              accept(value);
              cleanup(modal_name);
            };
            promise_list[modal_name].reject = function (value) {
              reject(value);
              cleanup(modal_name);
            };
            if (promise_list[modal_name].accept_value) {
              accept(promise_list[modal_name].accept_value);
              cleanup(modal_name);
            } else if (promise_list[modal_name].reject_value) {
              reject(promise_list[modal_name].reject_value);
              cleanup(modal_name);
            }
          });
          promise_list[modal_name].promise = returnValue;
          return returnValue;
        } else if (action.type === MODAL_CONFIRM) {
          promise_list[modal_name].accept_value = action.value;
          if (promise_list[modal_name].accept) promise_list[modal_name].accept(action.value);
        } else if (action.type === MODAL_CANCEL) {
          promise_list[modal_name].reject_value = action.value;
          if (promise_list[modal_name].reject) promise_list[modal_name].reject(action.value);
        } else if (action.type === HIDE_MODAL) {
          if (promise_list[modal_name].reject) promise_list[modal_name].reject('modal_closed');
          promise_list[modal_name].promise = null;
          cleanup(modal_name);
        }
        return nextAction;
      };
    };
  };
}
export default buildMiddleware;